import type { Theme, SxProps } from "@mui/material/styles";

/**
 * Styles for Color Circle Renderer component
 */
export const colorCircleStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  colorCircle: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    display: "inline-block",
  },
});
